// Login Page Component
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Row, Col, Input, notification } from 'antd';
import { ThemeForm, ThemeButton, ThemeCheckbox } from '../Styles/Theme';
import { loginApi, loginReset } from '../../store/actions/loginAction';
import { setPermissions } from '../../store/actions/permissionsAction';
import { handleInputChange } from '../../utils/formFunctions';
import { STORAGE_KEYS } from '../../utils/constants';
import { checkModulePermissions, getFirstAvailableRoute, isLogin, getExpiresAt } from '../../utils/helpers';
import { LoginWrapper } from './LoginStyle';
import { LockOutlined, MailOutlined, UserOutlined } from '@ant-design/icons';

const Login = (props) => {
	const { login, loginReset, loginState, setPermissions } = props;
	const [form] = ThemeForm.useForm();
	const [formData, setFormData] = useState({});
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		if (isLogin()) {
			let expiresAt = getExpiresAt();
			if (expiresAt !== null && new Date() < new Date(expiresAt)) {
				navigate('/');
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (loginState.apiState === 'success') {
			setLoading(false);
			// Store tokens and user data
			if (loginState.data) {
				localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, loginState.data.accessToken);
				localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, loginState.data.refreshToken);
				localStorage.setItem(STORAGE_KEYS.USER_DATA, JSON.stringify(loginState.data.user));
				if (loginState.data.expiresAt) {
					localStorage.setItem('expiresAt', loginState.data.expiresAt);
				}
				if (loginState.data.permissions) {
					localStorage.setItem(STORAGE_KEYS.PERMISSIONS, JSON.stringify(loginState.data.permissions));
					setPermissions(loginState.data.permissions);
				}
			}
			loginReset();
			// Check permissions after login - following reference pattern
			const dashboardPermission = checkModulePermissions('dashboard');
			if (dashboardPermission.authorized) {
				navigate('/');
			} else {
				const firstAvailableRoute = getFirstAvailableRoute();
				navigate(firstAvailableRoute ? firstAvailableRoute.path : '/');
			}
		} else if (loginState.apiState === 'error') {
			setLoading(false);
			// Check for specific error codes (code is nested in data.data)
			const errorCode = loginState.data?.data?.code;
			if (errorCode === 'ACCOUNT_PENDING') {
				notification.warning({
					message: 'Please set your password using the invitation email.',
				});
			} else if (errorCode === 'ACCOUNT_SUSPENDED') {
				notification.error({
					message: 'Account suspended. Contact your administrator.',
				});
			} else {
				notification.error({ message: loginState.message || 'Login failed' });
			}
			loginReset();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loginState]);

	return (
		<>
		<LoginWrapper>
			<Row gutter={[60, 16]}>
				<Col xs={{ span: 24, order: 1 }} sm={{ span: 24, order: 1 }} md={{ span: 12, order: 1 }} lg={{ span: 10, order: 1 }} xl={{ span: 10, order: 1 }}>
					<div className='loginLogo'>
						<img src='/images/logo.svg' />
					</div>
					<div className='loginContainer'>
						<h1>Sign in to CrowdVox</h1>
						{/* <p>If you don’t have an account register<br/>
						You can <Link to="/">Register here !</Link></p> */}
					<ThemeForm
						form={form}
						name="loginForm"
						layout="vertical"
						autoComplete="off"
						onFinish={() => {
							setLoading(true);
							login(formData);
						}}
						variant='underlined'
					>
						<ThemeForm.Item
							name="email"
							label="Email Address"
							rules={[
								{
									required: true,
									message: 'Please enter email address',
								},
							]}
						>
							<Input
								prefix={<MailOutlined className='mr-3' />}
								size={'large'}
								name="email"
								placeholder="Enter Email Address"
								onChange={(e) =>
									handleInputChange(
										e,
										formData,
										setFormData,
									)
								}
							/>
						</ThemeForm.Item>
						<ThemeForm.Item
						    className='mb-2'
							name="password"
							label="Password"
							rules={[
								{
									required: true,
									message: 'Please enter password',
								},
							]}
						>
							<Input.Password
							    prefix={<LockOutlined className='mr-3' />}
								name="password"
								size={'large'}
								placeholder="Enter Password"
								onChange={(e) =>
									handleInputChange(
										e,
										formData,
										setFormData,
									)
								}
							/>
						</ThemeForm.Item>
						{/* <Row gutter={[10, 10]}>
							<Col span={12}>
								<ThemeCheckbox>Remember me</ThemeCheckbox>
							</Col>
							<Col span={12} className='text-end'>
								<Link className='forgotPassword' to="/">Forgot Password?</Link>
							</Col>
						</Row> */}
						<ThemeForm.Item className="mt-8">
							{loading ? (
								<ThemeButton size='large' loading className='loginBtn'>
									Logging In...
								</ThemeButton>
							) : (
								<ThemeButton size='large' className='loginBtn' htmlType="submit">
									Log In
								</ThemeButton>
							)}
						</ThemeForm.Item>
					</ThemeForm>
					</div>
				</Col>
				<Col xs={{ span: 24, order: 1 }} sm={{ span: 24, order: 1 }} md={{ span: 12, order: 1 }} lg={{ span: 14, order: 1 }} xl={{ span: 14, order: 1 }}>
					<div className='loginBanner'>
						<img className='w-full h-full' src='/images/login-banner.png' alt='Login' />
					</div>
				</Col>
			</Row>
		</LoginWrapper>

		{/* <div className="min-h-screen flex items-center justify-center bg-gray-50">			
			<div className="max-w-md w-full space-y-8 p-8 bg-white rounded-lg shadow-md">
				<div>
					<h2 className="text-center text-3xl font-extrabold text-gray-900">
						Sign in to CrowdVox
					</h2>
				</div>
				<ThemeForm
					form={form}
					name="loginForm"
					layout="vertical"
					autoComplete="off"
					onFinish={() => {
						setLoading(true);
						login(formData);
					}}
				>
					<ThemeForm.Item
						name="email"
						label="Email Address"
						rules={[
							{
								required: true,
								message: 'Please enter email address',
							},
						]}
					>
						<Input
							size={'large'}
							name="email"
							placeholder="Enter Email Address"
							onChange={(e) =>
								handleInputChange(
									e,
									formData,
									setFormData,
								)
							}
						/>
					</ThemeForm.Item>
					<ThemeForm.Item
						name="password"
						label="Password"
						rules={[
							{
								required: true,
								message: 'Please enter password',
							},
						]}
					>
						<Input.Password
							name="password"
							size={'large'}
							placeholder="Enter Password"
							onChange={(e) =>
								handleInputChange(
									e,
									formData,
									setFormData,
								)
							}
						/>
					</ThemeForm.Item>

					<ThemeForm.Item className="mt-4">
						{loading ? (
							<ThemeButton type="primary" loading>
								Logging In...
							</ThemeButton>
						) : (
							<ThemeButton htmlType="submit">
								Log In
							</ThemeButton>
						)}
					</ThemeForm.Item>
				</ThemeForm>
			</div>
		</div> */}
		</>
	);
};

const mapStateToProps = (state) => ({
	loginState: state.login,
});

const mapDispatchToProps = (dispatch) => ({
	login: (params) => dispatch(loginApi(params)),
	loginReset: () => dispatch(loginReset()),
	setPermissions: (params) => dispatch(setPermissions(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);

